import { Order } from '@cemex-core/cmx-api';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { LotCapacity } from '@cemex-core/cmx-api/models/jobsite-std-lot/lot-capacity';
import { Action } from '@ngrx/store';
import { OneClickProject } from '../models/one-click-project.model';

export enum OneClickJobsitesActionTypes {
  LOAD_JOBSITES = '[One Click] Load jobsites',
  PRELOAD_JOBSITE = '[One Click] Preload jobsites',
  LOAD_JOBSITES_COMPLETE = '[One Click] Load jobsites completed',
  LOAD_JOBSITES_SALES_AREA = '[One Click] Load jobsite sales area',
  LOAD_JOBSITES_SALES_AREA_COMPLETE = '[One Click] Load jobsite sales area completed',
  SELECT_JOBSITE = '[One Click] Select jobsite',
  LOAD_STD_LOT = '[One Click] Load jobsite std lot',
  LOAD_STD_LOT_COMPLETED = '[One Click] Load jobsite std lot completed',
  RESET = '[One Click] Jobsite reset',
}

export class OneClickLoadJobsitesAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_JOBSITES;

  constructor() {}
}

export class OneClickPreLoadJobsitesAction implements Action {
  readonly type = OneClickJobsitesActionTypes.PRELOAD_JOBSITE;

  constructor(public payload: Order) {}
}

export class OneClickLoadJobsitesCompleteAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_JOBSITES_COMPLETE;

  constructor(public payload: any[]) {}
}

export class OneClickLoadJobsiteSalesAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_JOBSITES_SALES_AREA;

  constructor() {}
}

export class OneClickLoadJobsiteSalesAreaCompleteAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_JOBSITES_SALES_AREA_COMPLETE;

  constructor(public payload: IJobsiteSalesArea) {}
}

export class OneClickSelectJobsiteAction implements Action {
  readonly type = OneClickJobsitesActionTypes.SELECT_JOBSITE;

  constructor(public payload: OneClickProject) {}
}

export class OneClickLoadJobsiteStdLotAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_STD_LOT;

  constructor() {}
}

export class OneClickLoadJobsiteStdLotCompletedAction implements Action {
  readonly type = OneClickJobsitesActionTypes.LOAD_STD_LOT_COMPLETED;

  constructor(public payload: LotCapacity) {}
}

export class OneClickResetJobsitesAction implements Action {
  readonly type = OneClickJobsitesActionTypes.RESET;

  constructor() {}
}

export type OneClickJobsiteActions =
  | OneClickLoadJobsitesAction
  | OneClickLoadJobsiteSalesAction
  | OneClickLoadJobsitesCompleteAction
  | OneClickLoadJobsiteSalesAreaCompleteAction
  | OneClickSelectJobsiteAction
  | OneClickLoadJobsiteStdLotAction
  | OneClickLoadJobsiteStdLotCompletedAction
  | OneClickResetJobsitesAction;
